module.exports = __webpack_public_path__ + "img/home-6.9e55aacc.webp";